import { MeasurementRoutes } from 'app/features/measurement';
import { UserRoutes } from 'app/features/user';
import { LocationRoutes } from 'app/features/location';
import { DeviceRoutes } from 'app/features/device';
import { TenantRoutes } from 'app/features/tenant/tenant.routes';

export const APP_ROUTES = {
    Login: 'login',
    Root: '',
    User: 'user',
    UserList: `user/${UserRoutes.UserList}`,
    UserProfile: `user/${UserRoutes.UserProfile}`,
    Dashboard: 'dashboard',
    Measurement: `measurement`,
    MeasurementList: `measurement/${MeasurementRoutes.MeasurementList}`,
    Location: 'location',
    LocationList: `location/${LocationRoutes.LocationList}`,
    Device: 'device',
    DeviceList: `device/${DeviceRoutes.DeviceList}`,
    DeviceUpgrade: `device/${DeviceRoutes.DeviceUpgrade}`,
    FirmwareList: `device/${DeviceRoutes.FirmwareList}`,
    Tenant: 'tenant',
    TenantList: `tenant/${TenantRoutes.TenantList}`,
    Help: 'help'
};
